import { CalendarTodayOutlineIcon } from './CalendarTodayOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 9ACB9882-BE7B-44A3-AFCC-FDA2A5061EF1
 * name calendar-today-outline
 * version: 6.7.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/calendar-today-outline.svg
 * tags
 * - Date / Time 
 */
export const CalendarDayOutlineIcon = CalendarTodayOutlineIcon;
export default CalendarDayOutlineIcon